// src/context/SwalContext.js
import React, { createContext, useContext } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const ReactSwal = withReactContent(Swal);

const SwalContext = createContext();

export const useSwal = () => {
  return useContext(SwalContext);
};

export const SwalProvider = ({ children }) => {
  const alert = async (type, message, title = '', options = {}) => {
    // Set default options based on type
    const defaultOptions = {
      title: title || (type === 'success' ? 'Success' : type === 'error' ? 'Error' : 'Notice'),
      text: message,
      icon: type, // 'success', 'error', 'warning', 'info', 'question'
      ...(options.showCancelButton
        ? {} // No default confirm button if confirmation buttons are shown
        : { confirmButtonText: 'OK' }),
      ...options,
      ...options,
    };

    // Customize options for a success alert if needed
    if (type === 'success' && !options.showCancelButton) {
      defaultOptions.showConfirmButton = false;
      defaultOptions.showCancelButton = false;
      defaultOptions.timer = 1500; // Auto-close after 1.5 seconds
      defaultOptions.timerProgressBar = true;
    }

    try {
      const result = await ReactSwal.fire(defaultOptions);
      return result.isConfirmed;       
    } catch (error) {
      console.error('Failed to display alert:', error);
      return false;
    }
  };

  return (
    <SwalContext.Provider value={alert}>
      {children}
    </SwalContext.Provider>
  );
};
